<div class="unauthorized-top">
  <img src="./assets/peregrine-logo-white_black.svg" class="logo" alt="Imagine" height="80" width="250" />
  <h2>Unauthorized</h2>
  <p>You are not authorized to view this content and will be logged out shortly.</p>
</div>
